import React from "react";
import { featuredProjects } from "../mockdata";
import { Link, useNavigate } from "react-router-dom";
import { useEffect } from "react";

const FeaturedProjects = () => {
  useEffect(() => {
  const scrollY = sessionStorage.getItem("featuredScroll");
  if (scrollY) {
    window.scrollTo({ top: parseInt(scrollY, 10), behavior: "smooth" });
    sessionStorage.removeItem("featuredScroll");
  }
}, []);

  const navigate = useNavigate();
  return (
    <section className="w-full relative py-20 px-12 bg-gradient-to-br from-slate-100 via-slate-50 to-white overflow-hidden">
      {/* Enhanced Layered Wavy SVG Background */}
      <svg
        className="absolute left-0 top-0 w-full h-full opacity-60 pointer-events-none select-none"
        aria-hidden="true"
        focusable="false"
        viewBox="0 0 1440 500"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="none"
      >
        <defs>
          <linearGradient id="wave1" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#c7d2fe" />
            <stop offset="100%" stopColor="#e0e7ef" />
          </linearGradient>
          <linearGradient id="wave2" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#60a5fa" />
            <stop offset="100%" stopColor="#e0e7ef" />
          </linearGradient>
        </defs>
        <path
          d="M0,320 C360,420 1080,120 1440,320 L1440,500 L0,500 Z"
          fill="url(#wave1)"
          fillOpacity="0.7"
        />
        <path
          d="M0,400 C400,500 1040,200 1440,400 L1440,500 L0,500 Z"
          fill="url(#wave2)"
          fillOpacity="0.6"
        />
        <path
          d="M0,380 Q720,480 1440,380 L1440,500 L0,500 Z"
          fill="#fff"
          fillOpacity="0.4"
        />
      </svg>
      <div className="max-w-7xl mx-auto relative z-10">
        {/* Header Row */}
        <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-8">
          <div>
            <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-2">
              Featured Projects
            </h2>
            <div className="w-20 h-1 bg-red-600 rounded mb-2"></div>
          </div>
          <Link
            to="/projects"
            className="mt-4 md:mt-0 px-6 py-2 border border-black text-black font-medium hover:bg-black hover:text-white transition rounded no-underline"
          >
            Visit All Projects
          </Link>
        </div>
        {/* Description */}
        <p className="text-gray-700 text-base md:text-lg mb-12 max-w-4xl">
          Explore our MEP projects, where precision meets innovation. From
          cutting-edge designs to seamless execution, we deliver solutions that
          redefine excellence in the mechanical, electrical, and plumbing
          domains.
        </p>
        {/* Projects Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {featuredProjects.map((project, idx) => (
            <div
              key={idx}
              className="flex flex-col items-center cursor-pointer rounded-lg shadow-md transition-all duration-300 hover:shadow-2xl hover:-translate-y-2 hover:scale-105 hover:border-blue-900 border border-transparent bg-white"
              onClick={() => {
                sessionStorage.setItem("featuredScroll", window.scrollY);
                navigate(`/projects/${project.id || idx + 1}`, {
                  state: { fromFeatured: true },
                });
              }}
            >
              <img
                src={project.image}
                alt={project.title}
                className="w-full h-64 object-cover rounded-lg shadow-md mb-4"
              />
              <h3 className="text-xl font-bold text-gray-900 text-center">
                {project.title}
              </h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturedProjects;
